import { global } from ":global";
import type { ApiResponse } from "./_model";

export async function updateRequest(props: ApiResponse.GetRequests[number]) {
  return global.api.putAuth(`support/requests/${String(props?.id)}/`, { status: "solved" }).then((res) => {
    return res.data;
  });
}
